<div class="page-innder-body portlet light ">
  <div class="portlet-body">
    <!-- Skeleton Loader -->
    @if (loading) {
      <div class="skeleton-loader">
        <div class="d-flex justify-content-between align-items-center py-3" style="border-bottom: 1px solid #e9ecef;">
          <div class="skeleton" style="width: 200px; height: 28px;"></div>
          <div class="skeleton" style="width: 140px; height: 36px; border-radius: 6px;"></div>
        </div>
        <div class="skeleton" style="width: 60%; height: 40px; border-radius: 6px; margin: 16px 0;"></div>
        <div class="d-flex py-2" style="border-bottom: 1px solid #e9ecef; gap: 16px;">
          <div class="skeleton" style="width: 30%; height: 18px;"></div>
          <div class="skeleton" style="width: 35%; height: 18px;"></div>
          <div class="skeleton" style="width: 20%; height: 18px;"></div>
          <div class="skeleton" style="width: 12%; height: 18px;"></div>
        </div>
        @for (i of [1,2,3,4,5,6,7,8]; track i) {
          <div class="d-flex py-3" style="border-bottom: 1px solid #f1f5f9; gap: 16px;">
            <div class="skeleton" style="width: 30%; height: 16px;"></div>
            <div class="skeleton" style="width: 35%; height: 16px;"></div>
            <div class="skeleton" style="width: 20%; height: 16px;"></div>
            <div class="skeleton" style="width: 12%; height: 16px;"></div>
          </div>
        }
      </div>
    }

    @if (!loading) {
      <div class="table-toolbar">
        <div class="row">
          <div class="col-md-12">
            <p-toolbar>
              <div class="p-toolbar-group-start" style="font-size:x-large;">{{ 'emailEvents.systemEvents' | transloco }} @if (emailEvents.length > 0) {
                ({{ emailEvents.length }})
              }</div>
              <div class="p-toolbar-group-end">
                <p-button type="button" icon="fa fa-plus" [label]="'emailEvents.addNewEvent' | transloco" [outlined]="true"
                (click)="onShowEmailEventsDialog()"></p-button>
              </div>
            </p-toolbar>
          </div>
        </div>
      </div>
      <div class="table-responsive mt-3">
        <p-table #dt [value]="emailEvents" dataKey="ArtistId" [rowHover]="true"
          styleClass="p-datatable-gridlines p-datatable-striped"
          [globalFilterFields]="['Name', 'CreatedDate']" [paginator]="emailEvents.length >15"
          [rows]="15" [reorderableColumns]="true" [reorderableColumns]="true" [resizableColumns]="false">
          <!-- Table Caption Template -->
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="row">
                <div class="col-md-8 text-right">
                  <!-- Search Box -->
                  <div
                    class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                    <button type="button"
                      class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                      <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                    </button>
                    <input type="text"
                      class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                      (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'emailEvents.search' | transloco" />
                    </div>
                  </div>
                  <div class="col-md-4 text-left">
                  </div>
                </div>
              </div>
            </ng-template>
            <!-- Table Header Template -->
            <ng-template let-rowIndex="rowIndex" pTemplate="header" let-rowData>
              <tr>
                <th [pSortableColumn]="'Event'">{{ 'emailEvents.event' | transloco }}</th>
                <th [pSortableColumn]="'Description'">{{ 'emailEvents.description' | transloco }}</th>
                <!-- <th [pSortableColumn]="'Parameter'">Parameter</th> -->
                <th [pSortableColumn]="'CreatedDate'">{{ 'emailEvents.createdDate' | transloco }}</th>
                <th>{{ 'emailEvents.actions' | transloco }}</th>
              </tr>
            </ng-template>
            <!-- Table Body Template -->
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
              <tr>
                <td>
                  <div class="">
                    {{rowData.Name}}
                    @if (rowData.IsPredefined) {
                      @if (rowData.IsPredefined) {
                        <span class="badge"
                          [ngStyle]="{'background-color': '#178d9b', 'color': 'white'}">
                          {{ 'emailEvents.system' | transloco }}
                        </span>
                      }
                    }
                  </div>
                </td>
                <td>{{rowData.Description}}</td>
                <td>{{rowData.CreatedDate | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td>
                  @if (!rowData.IsPredefined) {
                    <div class="d-flex justify-content-center align-items-center" >
                      <button pButton (click)="editEmailEvent(rowData.Id)" class="p-button p-button-sm ms-2 p-button-outlined"
                        icon="pi pi-pencil" size="small" [pTooltip]="'emailEvents.editEvent' | transloco" tooltipPosition="top">
                      </button>
                      <button pButton (click)="onDeleteEmailEvent(rowData.Id)"
                      class="p-button-danger p-button-sm p-button-outlined ms-2" icon="pi pi-trash" size="small"></button>
                    </div>
                  }
                </td>
              </tr>
            </ng-template>
            <!-- Empty Message Template -->
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="7">
                  <div class="text-center">{{ 'emailEvents.noRecordsFound' | transloco }}</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
  </div>

  @if (isAddEmailEventDailogVisible) {
    <email-events-dailog [isAddEmailEventDailogVisible]="isAddEmailEventDailogVisible" [isEditMode]="isEditMode" [emailEventsFormData]="emailEventsFormData" [emailParameters]="emailParameters" [selectedEmailParameters]="selectedEmailParameters" (getEmailEvents)="getEmailEvents()" (onCloseEmailEventDailog)="onCloseEmailEventsDialog($event)"></email-events-dailog>
  }